import React, { FC } from 'react'
import { TControls } from '../../../../features/userInfoForm/types'
import PostCodeBase from './PostCodeBase'

const label = 'Previous Post code *'
const name = 'prevPostCode'

const PrevPostCode: FC<TControls> = ({ control }) =>
  <PostCodeBase label={label} name={name} control={control}/>

export default PrevPostCode
